<template>
  <div class="app_second">
    <!-- 表单 -->
    <div class="table1">
      <!-- 头部四个按钮 -->
      <div class="btns">
        <el-button type="primary" @click="xinzeng()">新增排班</el-button>
        <el-button type="info" @click="edit">编辑排班</el-button>
        <el-button type="danger" @click="delete_work_content()">删除排班</el-button>
      </div>
      <!-- 点击新增排班时的弹出框 -->
      <el-dialog title="新增排班" :visible.sync="dialogFormVisible">
        <!-- 弹话框内容 -->
        <el-form :model="form">
          <!-- 医生 -->
          <el-form-item label="医  生:" :label-width="formLabelWidth">
            <el-select v-model="doctorSelected" style="width: 40%">
              <el-option v-for="item in doctor" :key="item.id" :value="item.name"></el-option>
            </el-select>
            <el-input type="hidden" name="医生id" v-model="doctorId"></el-input>
          </el-form-item>

          <!-- 挂号类型 -->
          <el-form-item label="挂号类型:" :label-width="formLabelWidth" style="margin-top: -40px">
            <el-select v-model="form.register_selected" style=";width: 40%">
              <el-option v-for="(item,index) in form.register" :key="index" :value="item.type"></el-option>
            </el-select>
          </el-form-item>

          <!-- 排班时段 -->
          <el-form-item label="排班时段:" style="margin-left:9px ">
            <!-- 日选择 -->
            <el-date-picker
              v-model="form.time_selected"
              type="date"
              placeholder="选择日期"
              :picker-options="form.pickerOptions0"
              style="width: 37%"
            ></el-date-picker>

            <!-- 时间段选择 -->
            <el-time-select
              placeholder="起始时间"
              style="width: 20%"
              v-model="form.startTime"
              :picker-options="{
				  		     	       start: '08:00',
				  		     	       step: '05:00',
				  		     	       end: '13:00'
				  		     	     }"
            ></el-time-select>
            <el-time-select
              placeholder="结束时间"
              style="width: 20%"
              v-model="form.endTime"
              :picker-options="{
				  		     	      start: '11:30',
				  		     	      step: '00:30',
				  		     	      end: '16:00',
				  		     	      minTime: form.startTime
			  		     	    	}"
            ></el-time-select>
          </el-form-item>
		  <!-- 排班方案 -->
          <el-form-item label="排班方案:" :label-width="formLabelWidth">
            <el-select v-model="planSelected" style="width: 40%">
              <el-option v-for="item in plan" :key="item.plan_id" :value="item.name"></el-option>
            </el-select>
            <el-input type="hidden" name="方案id" v-model="planId"></el-input>
          </el-form-item>
          <div style="width: 50%;float: right">
            <span style ="color: #ff5435;">温馨提示：</span>11:30至13:00为休息时间
          </div>
        </el-form>

        <!-- 弹话框的低下两个按钮 -->
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="add">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 点击编辑排班时的弹出框 -->
      <el-dialog title="编辑排班" :visible.sync="edit_dialogFormVisible">
        <!-- 弹话框内容 -->
        <el-form :model="form">
          <!-- 挂号类型 -->
          <el-form-item label="挂号类型:" :label-width="formLabelWidth">{{form.register_selected}}</el-form-item>

          <!-- 医生 -->
          <el-form-item label="医 生:" :label-width="formLabelWidth">{{form.yisheng}}</el-form-item>

          <!-- 排班时段 -->
          <el-form-item label="排班时段:">
            {{form.selectTime}}
            <!-- 时间段选择 -->
            <el-time-select
              placeholder="起始时间"
              style="width: 25%"
              v-model="form.startTime"
              :picker-options="{
				  		     	       start: '08:00',
				  		     	       step: '05:00',
				  		     	       end: '13:00'
				  		     	     }"
            ></el-time-select>
            <el-time-select
              placeholder="结束时间"
              style="width: 25%"
              v-model="form.endTime"
              :picker-options="{
				  		     	      start: '11:30',
				  		     	      step: '00:30',
				  		     	      end: '16:00',
				  		     	      minTime: form.startTime
			  		     	    	}"
            ></el-time-select>
          </el-form-item>
		  <!-- 排班方案 -->
          <el-form-item label="排班方案:" :label-width="formLabelWidth">{{form.schedule_plan_name}}</el-form-item>
        </el-form>

        <!-- 编辑排班-弹话框的低下两个按钮 -->
        <div slot="footer" class="dialog-footer">
          <el-button @click="edit_dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="edit_sure">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 表单 -->
      <table border="1" cellspacing="0">
        <tr style="background-color:#f2f2f2;height: 50px;color: #a4a7af">
          <td v-for="(item,index) in arr" :key="index">
            <span>{{item}}</span>
          </td>
        </tr>
        <tr style="background-color: #f2f2f2;height: 30px;color: #a4a7af;line-height: 0">
          <td v-for="(item,index) in dayNames" :key="index">
            <span>{{item}}</span>
            <br>
          </td>
        </tr>
        <tr class="td_65px">
          <td v-for="(item,week_index) in weeks_content" :key="week_index" width="10%">
            <span
              v-for="(item1,todo_index) in item.todos"
              :key="todo_index"
              @click="find_index(week_index,todo_index)"
              :class="{spancolor:item1.findIndex_active == 'true',isvalue:item1.doctor_selected!=='暂无排班'}"
            >
              <br>
              {{ item1.doctor_selected }}
              <br>
              {{ item1.startTime }}
              {{ item1.endTime }}
              <br>
			  {{ item1.schedule_plan_name }}
              <br>
            </span>
          </td>
        </tr>
      </table>
      <el-button type="info" plain @click="back" style="margin:20px 2%">返回</el-button>
    </div>
  </div>
</template>
<style type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
.app_second .table1 {
  width: 87%;
  padding-bottom: 100px;
  position: absolute;
  margin: 20px 0;
}

.app_second table {
  clear: left;
  border-color: rgba(255, 255, 255, 0.5);
  background: #ffffff;
  width: 98%;
  margin-left: 18px;
  /*margin: 20px 20px;*/
}

.app_second table {
  text-align: center;
}

.app_second table span {
  display: block;
}

.app_second .td_65px {
  height: 300px;
  opacity: 0.7;
}

.app_second .btns {
  margin-left: 18px;
  margin-bottom: 10px;
}

.app_second .btn_foot {
  margin-left: 18px;
  border: none;
  width: 80px;
  height: 30px;
  background: #f4f4f4;
}

.app_second .btn_add {
  background: green;
  color: #ffffff;
}

.isvalue {
  background-color: rgba(227, 177, 0, 0.58);
}

.spancolor {
  background: #0172d0;
}
</style>
<script>
import { formatDate } from "../../common/date";

var myDate = new Date();
export default {
  data() {
    return {
      doctor: [],
	  plan: [],
      arr: [],
      doctorId: "",
	  planId: 0,
      doctorSelected: "",
	  planSelected: "",
      weekText: "本周",
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      todayTime_value: Date.now(),
      year: myDate.getFullYear(),
      month: myDate.getMonth() + 1,
      day: myDate.getDate(),
      //
      // 所有科室

      //7个休息
      scheduling_id: "",
      weeks_content: [
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              register_selected: "",
              selectTime: "",
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              register_selected: "",
              selectTime: "",
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              register_selected: "",
              selectTime: "",
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              register_selected: "",
              selectTime: "",
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              register_selected: "",
              selectTime: "",
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              register_selected: "",
              selectTime: "",
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              register_selected: "",
              selectTime: "",
              date: "",
              doctor_id: ""
            }
          ]
        }
      ],
      which_weekDay: myDate.getDay(),
      dayNames: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日"
      ],

      // 拿到删除的下标
      todo_index: "",
      week_index: "",
      dialogFormVisible: false,
      edit_dialogFormVisible: false,
      add_catchUp_dialogFormVisible: false,
      form: {
        register: [{ type: "专家门诊" }],
        register_selected: "专家门诊",

        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        time_selected: Date.now(),
        year_selected: "",
        mon_selected: "",
        day_selected: "",
        region: "",
        startTime: "",
        endTime: "",
        selectTime: "",
        yisheng: ""
      },

      formLabelWidth: "80px"
    };
  },
  mounted: function() {
    this.arr = JSON.parse(this.$route.query.obj);
    this.getinfo();
    var rolename = { rolename: "医生" };
    //获取医生的接口
    this.$axios({
      url: "/api/user/usersByRolename",
      method: "GET",
      params: rolename
    })
      .then(res => {
        this.doctor = res.data.data;
      })
      .catch(err => {
        this.$message.error("数据获取失败");
      });
	this.$axios({
      url: "/api/schedule/getplans",
      method: "GET",
    })
      .then(res => {
        this.plan = res.data.data;
		this.planID = res.data.data[0].plan_id;
		this.planSelected = res.data.data[0].name;
      })
      .catch(err => {
        this.$message.error("数据获取失败");
      });
	
  },

  methods: {
    //获取排班信息的接口
    getinfo: function() {
      var startDate = {
        startDate: this.arr[0],
        endDate: this.arr[6]
      };
      this.$axios({
        url: "/api/schedule/getinfos",
        method: "GET",
        params: startDate
      })
        .then(su => {
          for (var k = 0; k < su.data.length; k++) {
            if (su.data[k].todos.length === 0) {
              this.weeks_content[k].todos = [
                {
                  scheduling_id: "",
                  doctor_selected: "暂无排班",
                  time_start: "",
                  time_end: "",
                  register_selected: "",
                  selectTime: "",
                  findIndex_active: false,
                  date: "",
                  doctor_id: ""
                }
              ];
            } else {
              this.weeks_content[k].todos = su.data[k].todos;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    xinzeng: function() {
      if (this.week_index !== "") {
        this.form.time_selected = this.arr[this.week_index];
        this.dialogFormVisible = true;
      } else {
        this.$alert("请选择要新增的时间");
      }
    },

    add: function() {
      this.dialogFormVisible = false;
      let thisDate = formatDate(this.form.time_selected, "yyyy-MM-dd");

      for (let k = 0; k < this.doctor.length; k++) {
        if (this.doctor[k].name === this.doctorSelected) {
          this.doctorId = this.doctor[k].id;
        }
      }
	  for (let k = 0; k < this.plan.length; k++) {
        if (this.plan[k].name === this.planSelected) {
          this.planId = this.plan[k].plan_id;
        }
      }
      if (this.week_index !== "") {
        var a = this.doctorSelected;
        var b = this.form.startTime;
        var c = this.form.endTime;
        var d = formatDate(this.form.time_selected, "yyyy-MM-dd");
        var e = this.form.register_selected;
        var f = this.doctorId;
		var g = this.planId;
        let addoneinfo = {
          doctor_selected: a,
          startTime: b,
          endTime: c,
          date: d,
          register_selected: e,
          doctor_id: f,
		  plan_id: g
        };
        if (a == "") {
          this.$alert("请选择医生");
          return false;
        }
        if (b != "" && c != "") {
          this.$axios({
            url: "/api/schedule/addone",
            method: "POST",
            data: addoneinfo
          })
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "新增成功"
                });
                this.getinfo();
              } else {
                this.$alert(res.data.msg);
              }
            })
            .catch(err => {
              if (err.data === "failed") {
                this.$message({
                  message: "增加失败",
                  type: "success"
                });
              }
            });
        } else {
          this.$alert("请选择完整信息");
        }
      } else {
        this.$alert("请选择一个时间");
      }

      // }
    },

    find_index: function(week_index, todo_index) {
      this.week_index = week_index;
      this.todo_index = todo_index;

      this.weeks_content[this.week_index].todos[
        this.todo_index
      ].findIndex_active = "true";
      for (var i = 0; i < 7; i++) {
        var todosLength = this.weeks_content[i].todos.length;
        for (var j = 0; j < todosLength; j++) {
          if (i == week_index && j == todo_index) {
            continue;
          }
          this.weeks_content[i].todos[j].findIndex_active = "false";
        }
      }
    },

    //删除选中数据
    delete: function() {
      let scheduling_id = this.weeks_content[this.week_index].todos[
        this.todo_index
      ].scheduling_id;
      let aa = { scheduling_id: scheduling_id };
      this.$axios({
        url: "/api/schedule/deleteone",
        method: "DELETE",
        params: aa
      })
        .then(
		//su => {
        //  this.$message({ message: "删除成功", type: "success" });
        //  this.getinfo();
          //this.items = su.data
		  res => {
                    if (res.data == "failed") {
                        this.$message({ message: "删除失败", type: "failed"});
                        this.getinfo();
                    }
                    else {
                        this.$message({ message: "删除成功", type: "success" });
						this.getinfo();
                    }
        })
        .catch(err => {
          console.log(err);
        });
    },
    delete_work_content: function() {
      if (
        this.weeks_content[this.week_index].todos[this.todo_index]
          .doctor_selected !== "暂无排班"
      ) {
        let check = {
          doctorId: this.weeks_content[this.week_index].todos[this.todo_index]
            .doctor_id,
          inquiryDate: this.weeks_content[this.week_index].todos[
            this.todo_index
          ].date
        };
        this.$axios({
          url: "/api/schedule/check/toreservation/status",
          method: "GET",
          params: check
        })
          .then(res => {
            if (res.data.code == 200) {
              this.delete();
            } else {
              this.$alert("抱歉，已有病人预约，不能删除");
            }
          })
          .catch(err => {
            console.log(err.data);
          });
      }
    },

    //点击编辑按钮
    edit: function() {
      if (this.week_index !== "" && this.todo_index !== "") {
        this.edit_dialogFormVisible = true;
        this.form.register_selected = this.weeks_content[this.week_index].todos[
          this.todo_index
        ].register_selected;
        this.form.selectTime = this.weeks_content[this.week_index].todos[
          this.todo_index
        ].date;
        this.form.startTime = this.weeks_content[this.week_index].todos[
          this.todo_index
        ].startTime;
        this.form.endTime = this.weeks_content[this.week_index].todos[
          this.todo_index
        ].endTime;
        this.form.yisheng = this.weeks_content[this.week_index].todos[
          this.todo_index
        ].doctor_selected;
		this.form.schedule_plan_name = this.weeks_content[this.week_index].todos[
          this.todo_index
        ].schedule_plan_name;
        if (
          this.weeks_content[this.week_index].todos[this.todo_index]
            .doctor_selected === "暂无排班"
        ) {
          this.edit_dialogFormVisible = false;
        }
      } else {
        this.$alert("请选择一项数据");
      }
    },

    //编辑完确认方法
    Edit: function() {
      var scheduling_id = this.weeks_content[this.week_index].todos[
        this.todo_index
      ].scheduling_id;
      var doctor_id = this.weeks_content[this.week_index].todos[this.todo_index]
        .doctor_id;
      var doctor_selected = this.weeks_content[this.week_index].todos[
        this.todo_index
      ].doctor_selected;
      var register_selected = this.weeks_content[this.week_index].todos[
        this.todo_index
      ].register_selected;

      let edit = {
        scheduling_id: scheduling_id,
        doctor_id: doctor_id,
        doctor_selected: doctor_selected,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        date: this.form.selectTime,
        register_selected: register_selected
      };
      this.$axios({
        url: "/api/schedule/editone",
        method: "POST",
        data: edit
      })
        .then(res => {
          this.$message({ message: "编辑成功", type: "success" });
          this.getinfo();
        })
        .catch(err => {
          console.log(err.data);
        });
    },
    edit_sure: function() {
      let check = {
        doctorId: this.weeks_content[this.week_index].todos[this.todo_index]
          .doctor_id,
        inquiryDate: this.form.selectTime
      };
      this.$axios({
        url: "/api/schedule/check/toreservation/status",
        method: "GET",
        params: check
      })
        .then(res => {
          if (res.data.code == 200) {
            this.Edit();
          } else {
            this.$alert("抱歉，已有病人预约，不能编辑");
          }
        })
        .catch(err => {
          console.log(err.data);
        });

      this.edit_dialogFormVisible = false;
    },

    back: function() {
      this.$router.push({ path: "/home/arrange" });
    }
  }
};
</script>





// WEBPACK FOOTER //
// new_add_work.vue?55abd316